// deps
import React, { ReactElement, memo } from "react";

// components
import { Portal } from "@core-ui/components/portal";
import { OverflowHidden } from "@core-ui/components/side-effects";
import { OverlayStyled } from "./styles";

function UpdateProgressLoader(): ReactElement {
    return (
        <Portal>
            <OverflowHidden>
                <OverlayStyled visible={true} />
            </OverflowHidden>
        </Portal>
    );
}

export default memo(UpdateProgressLoader);
